import { useContext } from 'react';
import { UserContext } from '@providers/UserProvider/UserProvider';

import NotificationsProvider from '@components/providers/NotificationsProvider/NotificationsProvider';
import NotificationsDropdownButton from
  '@components/layout/Header/Notifications/NotificationsDropdownButton/NotificationsDropdownButton';
import { UserInfoDisplay } from '@components/layout/Header/SettingsDisplay/UserInfoDisplay';

import style from './SettingsDisplay.module.scss';
import { UserDropdown } from './UserDropdown';

const SettingsDisplay = () => {
  const user = useContext(UserContext);

  return (
    <div className={style.wrapper} id='dropdrown-wrapper'>
      <UserDropdown />
      {/* A real User object may not exist in development and on /sidekiq path */}
      {!!user.id && <UserInfoDisplay rightAlign />}
      {!!user.id && !user.is_super_admin && !user.is_deeplink && (
        <div className={style.notificationsButton}>
          <NotificationsProvider>
            <NotificationsDropdownButton />
          </NotificationsProvider>
        </div>
      )}
      <div style={{ clear: 'both' }} />
    </div>
  );
};

export default SettingsDisplay;
